import { gql } from '@apollo/client';

export const REMOVE_LINE_ITEMS = gql`
    mutation RemoveLineItems($cartId: String!, $lineItemIds: [String!]!) {
        removeLineItems(cartId: $cartId, lineItemIds: $lineItemIds) {
            isActiveCart
            id
            customLineItems {
                id
            }

            lineItemsV2 {
                id
            }
        }
    }
`;

export const REMOVE_CUSTOM_LINE_ITEMS = gql`
    mutation RemoveCustomLineItems($cartId: String!, $lineItemIds: [String!]!) {
        removeCustomLineItems(cartId: $cartId, lineItemIds: $lineItemIds) {
            isActiveCart
            id
            customLineItems {
                id
            }
            lineItemsV2 {
                id
            }
        }
    }
`;
